import PyramidPerSegment from './PyramidPerSegment';

export default PyramidPerSegment;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/pyramidPerSegment/index.js